/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
// import { ReactComponent as Facebook } from 'assets/facebook.svg';
// import { ReactComponent as Google } from 'assets/google.svg';
import { Categories as PlatformCategories } from 'models/business/Platform';
import Performance from 'models/business/Performance';
import activityImg from 'assets/activity.png';
import faxImg from 'assets/fax.png';
import wandImg from 'assets/wand.png';
import Styles from './index.module.css';
import RatingCard from './RatingCard';
import RatingLabel from './RatingLabel';

const rate = (current, previous) => (
  previous !== 0 ? Math.round(((current / previous) * 100) - 100) : 0
);

const conversionCalculation = (current, previous) => {
  const calculatedConversion = current.conversionRate - previous.conversionRate;
  return calculatedConversion;
};

const ctrCalculation = (current, previous) => {
  const calculatedCTR = current.clickThroughRate - previous.clickThroughRate;
  return calculatedCTR;
};

const customerPriceCalculation = (current, previous) => {
  const calculatedCP = previous.costPerCustomer !== 0
    ? ((current.costPerCustomer - previous.costPerCustomer) / previous.costPerCustomer) * 100
    : 0;
  return calculatedCP;
};

export default function PerformanceCard({ currentPerformance, previousPerformance }) {
  return (
    <div className={Styles.mainContainer}>
      <div className={Styles.platformContainer}>
        <div className={Styles.platformText}>{currentPerformance.platform === PlatformCategories.Google ? 'SSC' : 'CPAS'}</div>
      </div>
      <div className={Styles.roasContainer}>
        <div className={Styles.roasText}>ROAS</div>
        <div className={Styles.roasNumText}>
          {currentPerformance.returnOnAdSpend === 0 ? '資料不足' : currentPerformance.returnOnAdSpend.toFixed(2)}
        </div>
        <div className={Styles.roasButtomText}>廣告投資報酬率</div>
        <RatingLabel
          rating={rate(currentPerformance.returnOnAdSpend, previousPerformance.returnOnAdSpend)}
        />
      </div>
      <div className={Styles.ratingsContainer}>
        <RatingCard
          rating={ctrCalculation(currentPerformance, previousPerformance)}
          title="素材表現"
          measure="點擊率"
          icon={wandImg}
        />
        <RatingCard
          rating={conversionCalculation(currentPerformance, previousPerformance)}
          title="銷售轉換"
          measure="轉換率"
          icon={activityImg}
        />
        <RatingCard
          rating={customerPriceCalculation(currentPerformance, previousPerformance)}
          title="客單表現"
          measure="客單價"
          icon={faxImg}
        />
      </div>
    </div>
  );
}

PerformanceCard.propTypes = {
  currentPerformance: PropTypes.instanceOf(Performance),
  previousPerformance: PropTypes.instanceOf(Performance),
};

PerformanceCard.defaultProps = {
  currentPerformance: new Performance(),
  previousPerformance: new Performance(),
};
